import { graphql } from 'src/graphql';

import { UserFields } from 'src/fragments/userFields.fragment';

export const FetchUserById = graphql(
  `
    query FetchUserByID {
      userByID: viewer {
        ...UserFields
      }
    }
  `,
  [UserFields],
);
